<template>
    <div class="div-aside">
        <h3>网站导航</h3>
        <el-row>
            <el-link type="primary" href="/#/ProductList">药品列表</el-link>
        </el-row>
        <el-row>
            <el-link type="primary" href="/#/HotNews">聚美头条</el-link>
        </el-row>
        <el-row>
            <el-link type="primary" href="/#/License">许可证书</el-link>
        </el-row>
        <el-row>
            <el-link type="primary" href="/#/Record">网络备案</el-link>
        </el-row>
        <el-row>
            <el-link type="primary" href="/#/ContactUs">联系我们</el-link>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: 'Aside'
    }
</script>
<style scoped>
    .div-aside{
        height: 100%;
        background-color:rgba(255, 255, 255, 0.5);
    }
    .el-link{
        font-size: 20px;
        line-height: 40px;
    }
    .pdf-link{
        font-size: 20px;
        line-height: 40px;
        color: #409EFF;
        text-decoration: none;
    }
    .pdf-link:hover{
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/Aside.vue